import logo from './logo.svg';
import './App.css';

import React, { useState } from 'react'
import { render } from 'react-dom'
import {
  Box,
  Button,
  ButtonGroup,
  CSSReset,
  Heading,
  Icon,
  Link,
  ThemeProvider,
  theme,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Checkbox,
  Progress,
  Radio,
  RadioGroup,
  Stack,
  Textarea,
  Text,
  Image
} from '@chakra-ui/react'
import { Form, Field, useField, useForm } from 'react-final-form'
import validate from './Validate'
import FileField from './FileField';
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import {ref,     uploadBytesResumable,
  getDownloadURL } from "firebase/storage"




const App = () =>{ 
  const firebaseConfig = {
    apiKey: "AIzaSyDskTYs7OmUZx6oTg7aMGMn4Mc0p1zNz40",
    authDomain: "maturalni-cv.firebaseapp.com",
    projectId: "maturalni-cv",
    storageBucket: "maturalni-cv.appspot.com",
    messagingSenderId: "574365751297",
    appId: "1:574365751297:web:6a31fb0da2528e61cdc800"
  };
  // Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
const [uploadState, setUploadState] = useState(false);
const [pecrent, setPercent] = useState(0);
const onSubmit = async values => {
  if(values.file){
    await handleUpload(values.file[0], values)
  }
}

const handleUpload = async (file, values) => {
  setUploadState(true);
  const storageRef = ref(storage, `/files/${values.firstName}_${values.lastName}_CV_${Date.now().toString()}_${file.name}`)
  const uploadTask = uploadBytesResumable(storageRef, file);
  uploadTask.on(
    "state_changed",
    (snapshot) => {
        const percent = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );

        // update progress
        setPercent(percent);
    },
    (err) => console.log(err),
    () => {
        // download url
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
            values.file = url;
            
            
            fetch("https://script.google.com/macros/s/AKfycbz_8VqtPiKQf9ubV0tv_FlgvrrCzcfPFfTm9kdz4JY2LbG6pAoeXZrV8lIw4gJoWpag/exec", {
              method: "POST",
              mode: 'no-cors',
              headers: {'Content-Type': 'application/json',
            }, 
              body: JSON.stringify(values)
            }).then(() => {
              setUploadState(false);
              values.file = undefined;
              //window.alert(JSON.stringify(values, 0, 2) + "Wysłano formularz");
              window.alert("Wysłano formularz");
            }, err => {
              window.alert("Błąd dodawania" + err);
            });
        });
    }
); 
}

const AdaptedTextarea = ({ input, meta, ...rest }) => (
  <Textarea {...input} {...rest} isInvalid={meta.error && meta.touched} />
)

const CheckboxControl = ({ name, value, children }) => {
  const {
    input: { checked, ...input },
    meta: { error, touched, invalid }
  } = useField(name, {
    type: 'checkbox' // important for RFF to manage the checked prop
  })
  return (
    <FormControl isInvalid={touched && invalid} my={4}>
      <Checkbox {...input} isInvalid={touched && invalid} my={4}>
        {children}
      </Checkbox>
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  )
}

const CheckboxArrayControl = ({ name, value, children }) => {
  const {
    input: { checked, ...input },
    meta: { error, touched }
  } = useField(name, {
    type: 'checkbox', // important for RFF to manage the checked prop
    value // important for RFF to manage list of strings
  })
  return (
    <Checkbox {...input} isChecked={checked} isInvalid={error && touched}>
      {children}
    </Checkbox>
  )
}

const AdaptedRadioGroup = ({ input, meta, label, children }) => (
  <FormControl isInvalid={meta.touched && meta.invalid} my={4} margin="3em auto">
    <FormLabel htmlFor={input.name}>{label}</FormLabel>
    <RadioGroup {...input}>{children}</RadioGroup>
    <FormErrorMessage>{meta.error}</FormErrorMessage>
  </FormControl>
)

const Control = ({ name, ...rest }) => {
  const {
    meta: { error, touched }
  } = useField(name, { subscription: { touched: true, error: true } })
  return <FormControl {...rest} isInvalid={error && touched} />
}

const Error = ({ name }) => {
  const {
    meta: { error }
  } = useField(name, { subscription: { error: true } })
  return <FormErrorMessage>{error}</FormErrorMessage>
}

const InputControl = ({ name, label, required, description }) => {
  const { input, meta } = useField(name)
  return (
    <Control name={name} my={4}>
      <FormLabel htmlFor={name}>{label+required}</FormLabel>
      {description ? 
              <Text  fontSize="sm" textAlign="justify" margin="0.5em auto">
              {description}
            </Text>
        : <React.Fragment></React.Fragment>}
      <Input
        {...input}
        isInvalid={meta.error && meta.touched}
        id={name}
        placeholder={label}
      />
      <Error name={name} />
    </Control>
  )
}

const TextareaControl = ({ name, label, required }) => (
  <Control name={name} my={4}>
    <FormLabel htmlFor={name}>{label + (required || "")}</FormLabel>
    <Field
      name={name}
      component={AdaptedTextarea}
      placeholder={label}
      id={name}
    />
    <Error name={name} />
  </Control>
)

const PercentComplete = props => {
  const form = useForm()
  const numFields = form.getRegisteredFields().length
  const numErrors = Object.keys(form.getState().errors).length
  return (
    <Progress
      value={pecrent}
      {...props}
    />
  )
}


  
  return (
  <ThemeProvider theme={theme}>
    <CSSReset />
    <Box w={50+ "%"} p={4} m="20px auto" justifyContent="center">
      <Image width="50%" margin="auto" src='/maturalni.png' alt='Maturalni logo' />
      <Heading as="h1" size="xl" textAlign="center" m="2em auto" color="rgb(12 28 68)">
        Dołącz do nas! Wypełnij formularz aplikacyjny.
      </Heading>
      <Form
        onSubmit={onSubmit}
        validate={validate}
        render={({
          handleSubmit,
          form,
          errors,
          submitting,
          pristine,
          values
        }) => (
          <Box
            as="form"
            p={4}
            borderWidth="1px"
            rounded="lg"
            shadow="0 0 2em rgb(63 95 190)"
            onSubmit={handleSubmit}
          >
            {/* 
            This example uses a mixture of custom field components using useField() 
            and components adapted to take the { input, meta } structure <Field/>
            provides
            */}
            <InputControl name="firstName" label="Imię" required="*" />
            <InputControl name="lastName" label="Nazwisko" required="*" />
            <InputControl name="email" label="Adres email" required="*" />
            <InputControl name="phone" label="Telefon" required="*" />
            <InputControl name="town" label="Miasto" required="*" />
            <InputControl name="subject" label="W jakim przedmiocie się specjalizujesz?" required="*" />
            <InputControl name="availableTime" label="Ile czasu chciałbyś poświęcić na pracę z Maturalnymi? "  required="(Ilość godzin w tygodniu)*"/>
            <InputControl name="education" label="Twoje wykształcenie" required="*"  />
            <InputControl name="childEducationExperience" label="Określ swoje doświadczenie w nauczaniu dzieci/młodzieży" required="*" />
            <Field
              name="examinator"
              component={AdaptedRadioGroup}
              label="Czy jesteś egzaminatorem maturalnym*"
            >
              <Radio margin= "auto 1em" value="tak" color="black">
                Tak
              </Radio>
              <Radio value="nie" color="black">
                Nie
              </Radio>
            </Field>
            <Field
              name="workingAtSchool"
              component={AdaptedRadioGroup}
              label="Jestem nauczycielem czynnie pracującym w szkole (placówce oświatowej)*"
            >
              <Radio margin= "auto 1em" value="tak" color="black">
                Tak
              </Radio>
              <Radio value="nie" color="black">
                Nie
              </Radio>
            </Field>
            <InputControl name="workingSchool" label="W jakiej szkole pracujesz?" required={values && values.workingAtSchool === "tak" ? "*" : ""} />
            <TextareaControl name="currentWork" label="Opisz krótko czym się obecnie zajmujesz" required="*" />
            <TextareaControl name="specialFeatures" label="Co wyróżnia Cię jako nauczyciela?" required="*" />
            <TextareaControl name="achievments" label="Twoje osiągnięcia w pracy pedagogicznej?" required="*" />
            <TextareaControl name="notes" label="Czy jest coś, co dodatkowo chciałbyś nam przekazać?" />

            <FileField label="Załącz swoje CV" name="file" />
            <InputControl name="video" label="Link do wideo" required="*" description="Do swojego zgłoszenia dołącz max. 5-cio minutowe wideo, w którym pokażesz nam w jaki sposób przekazujesz wiedzę i pracujesz z uczniami (wideo w formie linku np. do Google Drive, YouTube, weTransfer itp.)" />
            { uploadState ?  <PercentComplete size="sm" my={5} hasStripe isAnimated /> : <React.Fragment></React.Fragment>}
            <Field
              name="rodo"
              component={AdaptedRadioGroup}
              label=""
              required="*"
            >
              <Radio value="Tak" color="black">
                <Text fontSize="sm" textAlign="justify" >Wyrażam zgodę na przetwarzanie moich danych osobowych dla potrzeb niezbędnych do realizacji procesu rekrutacji zgodnie z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO).</Text>
              </Radio>
            </Field>
            <ButtonGroup justifyContent="center" width="100%" spacing={4} paddingBlock={"auto 10px"}>
              <Button
                size="lg"
                isLoading={submitting}
                loadingText="Wysyłanie"
                type="submit"
              >
                Wyślij
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={form.reset}
                isDisabled={submitting || pristine}
              >
                Reset
              </Button>
            </ButtonGroup>
            {/* <Box as="pre" my={10}>
              {JSON.stringify(values, 0, 2)}
            </Box> */}
          </Box>
        )}
      />
    </Box>
  </ThemeProvider>
)}



export default App;
